import { ts } from '_core';

import { DraftParams, Params } from './types';

export const validate = (params: DraftParams) => {
  const signals = params?.analysis_pipelined_signals;
  if (!signals || !Array.isArray(signals) || signals.length === 0) {
    return ['One signal is required for correlation analysis.'];
  }
  const signal = signals[0];
  if (!signal?.signal_id) {
    return ['Signal is a required field.'];
  }
  return [];
};

const getSignalName = (col: string, resources: ts.StoreState['resources']): string => {
  const els = col.split('=>').map((e) => e.trim());
  if (els.length > 1) {
    const sppipe = els[2] ? (resources.pipelines.find((p) => p.handle === els[2])?.name ?? els[2]) : null;
    const pipe = els[1] ? (resources.pipelines.find((p) => p.handle === els[1])?.name ?? els[1]) : null;
    if (sppipe) return sppipe;
    if (pipe) return pipe;
  }
  const signalFromResources = resources.signals.find((s) => s.handle === els[0]);
  const signalName = signalFromResources?.name ?? els[0];
  return signalName;
};

export const prepareData = (
  data: ts.types.widgets.TableData,
  resources: ts.StoreState['resources']
): ts.types.widgets.TableData => {
  if (!data || !Array.isArray(data) || data.length === 0) return data;

  const prepareRow = (row: ts.types.widgets.TableData[0]) => {
    const newRow = {
      date: row.build_date,
    } as ts.types.widgets.TableData[0];
    Object.keys(row).forEach((col) => {
      if (col.includes('|')) {
        const parts = col.split('|').map((p) => p.trim());
        const displayCol = parts.map((part) => getSignalName(part, resources)).join(' | ');
        newRow[displayCol] = row[col];
      }
    });
    return newRow;
  };

  return data.map((row) => prepareRow(row));
};

export const getName = (
  params: Params,
  _context: ts.types.signal.SignalAnalysisContext,
  resources: ts.StoreState['resources']
): string => {
  const signals = params.analysis_pipelined_signals || [];
  const signal = signals[0];
  if (!signal?.signal_id) {
    return 'Correlation With Another Signal';
  }
  const selectedSignal = resources.signals.find((s) => s.id === signal.signal_id);
  const signalName = selectedSignal?.name ?? `Signal ${signal.signal_id}`;
  return `Signal Correlation with ${signalName}`;
};
